/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dlc-color-NA.dlc{color:#6c757d}.dlc-color-Conforme.dlc{color:#28a745}.dlc-color-NonConforme.dlc{color:#dc3545}.dlc{font-family:sans-serif}.dlc.date-input{width:110px;height:34px}"];
export { styles as styles };
